import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import "./Documents.scss";
import DocumentsStore from "./DocumentsStore";
import Loader from "../../shared/Loader/Loader";
import Swal from "sweetalert2";
import PDF from "../Monitor/PDF";
import { StatusIcon } from "../SnippetReport";
import Dotdotdot from "react-dotdotdot";
import {
  formatDateTime,
  formatDateTimeWithoutSeconds,
} from "../../shared/dateTimeUtils";
import _ from "lodash";

class Documents extends Widget {
  constructor(props) {
    super(props);
    this.setRouteProps(["asmpid"]);
    this.store = new DocumentsStore();
    this.store
      .fetchDocuments(this.asmpid)
      .then(() => this.observeRoute(this.props.location));
    this.selectDocument = this.selectDocument.bind(this);
    this.zoomChange = this.frameDebounce(this.zoomChange.bind(this));
    this.observeRoute = this.observeRoute.bind(this);
    this.refresh = this.refresh.bind(this);
    this.setReportResolution = this.setReportResolution.bind(this);
  }

  render() {
    let items = [];
    if (this.store.documents) {
      if (this.store.documents.length === 0) {
        items = [
          <div className={`document-item no-data`} key={0}>
            <span className="title">No Documents</span>
          </div>,
        ];
      } else {
        items = this.store.documents.map((documentItem, i) => {
          const resolution = documentItem.status;
          const showApproveButtons =
            documentItem.status === "Unapproved" &&
            this.props.store.mayApproveSnippet;

          return (
            <div
              {...this.className({
                "document-item": true,
                selected: this.store.documentIsSelected(documentItem),
                [`status-${resolution}`.toLowerCase()]:
                  this.props.store.mayApproveSnippet,
              })}
              onClick={() => this.selectDocument(documentItem)}
              key={i /* IDs in the list are non-unique */}
              ref={`docItem-${i}`}
            >
              <span className="title">
                <Dotdotdot clamp={3} useNativeClamp={false}>
                  <span>{documentItem.title}</span>
                </Dotdotdot>
                {resolution && resolution !== "Saved" ? (
                  <StatusIcon status={resolution} />
                ) : null}
              </span>

              <span className="type">{documentItem.type}</span>
              <span className="author">{documentItem.authorName}</span>
              {documentItem.dateTime.isValid ? (
                <span className="date">
                  {formatDateTime(documentItem.dateTime, "-")}
                </span>
              ) : null}
              {showApproveButtons ? (
                <div className="actions">
                  <button
                    className="btn primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setReportResolution(documentItem, "Approved");
                    }}
                  >
                    Approve
                  </button>
                  <button
                    className="btn reject"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setReportResolution(documentItem, "Rejected");
                    }}
                  >
                    Reject
                  </button>
                </div>
              ) : null}
            </div>
          );
        });
      }
    }

    let _document = null;
    if (this.store.document) {
      const format = this.store.document.format.toLowerCase();
      const title = this.store.document.title || "";
      _document = (
        <React.Fragment>
          <header>
            {`${title} • ${formatDateTimeWithoutSeconds(
              this.store.document.dateTime,
              "-",
            )}`}
          </header>
          <div className="document">
            {format === "pdf" ? (
              <PDF
                ref={(ref) => _.set(this, "ref.pdfCanvasContainer", ref)}
                base64Pdf={this.store.document.body}
                showZoomControls={true}
              />
            ) : (
              <div
                className="html-document"
                dangerouslySetInnerHTML={{
                  __html: atob(this.store.document.body),
                }}
              />
            )}
          </div>
        </React.Fragment>
      );
    } else {
      _document = (
        <div className={`document no-data`}>
          <header>No Documents</header>
        </div>
      );
    }

    return (
      <div className="documents widget">
        <div className="document-list">
          {this.store.documentsLoading ? <Loader /> : items}
        </div>
        <div className="document-container">
          {this.store.documentLoading ? <Loader /> : _document}
        </div>
      </div>
    );
  }

  refresh() {
    this.store.fetchDocuments(this.asmpid);
  }
  observeRoute() {
    setImmediate(() => {
      const { documentId, parentId } = this.props.match.params;
      this.store.selectDocumentItem({
        documentId,
        parentId,
        asmpid: this.asmpid,
      });
    });
  }

  selectDocument(documentItem) {
    this.props.history.push(
      `/patient/${this.asmpid}/documents/${documentItem.parentId}/${documentItem.documentId}`,
    );
  }

  zoomChange(e) {
    this.store.zoom = e.target.value;
  }

  setReportResolution(report, resolution) {
    let promise;
    if (report.loadingStatus) return;
    report.loadingStatus = true;
    if (resolution === "Approved") {
      promise = this.store.approveSnippet({ id: report.documentId });
    } else if (resolution === "Rejected") {
      promise = Swal.fire({
        title: "Reject Snippet",
        text: "Are you sure you want to Reject?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Reject",
        confirmButtonColor: "#C83232",
        cancelButtonColor: "#999",
      }).then((result) => {
        if (result.value) {
          return this.store.rejectSnippet({ id: report.documentId });
        } else {
          return "cancelled";
        }
      });
    }

    promise
      .then((res) => {
        if (res === "cancelled") return;
        report.status = resolution;
      })
      .finally((report.loadingStatus = false));
  }
}

export default inject("store")(observer(Documents));
